import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const RegenerateCustomCommercialInvoiceResultSchema_ = z.object({
  shipmentLabel: z.string(),
  success: z.boolean(),
  message: z.string(),
  pdfBase64: z.string().optional(),
  fileName: z.string().optional(),
});
export interface RegenerateCustomCommercialInvoiceResult extends z.infer<
  typeof RegenerateCustomCommercialInvoiceResultSchema_
> {}
export const RegenerateCustomCommercialInvoiceResultSchema: z.ZodType<RegenerateCustomCommercialInvoiceResult> =
  RegenerateCustomCommercialInvoiceResultSchema_;

export const regenerateCustomCommercialInvoice = unaryRpc({
  name: "regenerateCustomCommercialInvoice",
  input: z.object({ returnId: z.string() }),
  output: z.object({
    results: z.array(RegenerateCustomCommercialInvoiceResultSchema),
  }),
});
